import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const GeoImagesViewTopBar = memo(() => {
	return <BaseTopBar />
})
GeoImagesViewTopBar.displayName = "GeoImagesViewTopBar"
